import * as yup from 'yup';
import {
  requiredMsg,
  urlMsg,
} from '../../../Finance/components/TransactionModal/Forms/utils/validationMessages';
import { VALID_URL_REGEX } from '../../../../util/regex';

export const CreateListItemSchema = yup.object().shape({
  name: yup.string().required(requiredMsg('Name')),
  // Optional field: allow empty. Without excludeEmptyString, matches() rejects
  // '' and, since Submit gates on validity, wedges the button when no website.
  website: yup
    .string()
    .optional()
    .nullable()
    .matches(VALID_URL_REGEX, { message: urlMsg('Website'), excludeEmptyString: true }),
  sectorId: yup.number().required(requiredMsg('Sector')).nullable(),
  assignee: yup.number().optional().nullable(),
});
